//---------------------------------------------------
//  Nom du fichier : Connected.js 
//
//  Description: Component qui contient les bouton pour se diriger vers un autre page
//               se déconnecter, ouvrir la section recherche ou changer la langue du site
//
//  Auteur: Vega Laliberté et Alek Del Balso
//---------------------------------------------------


import React, { useEffect, useRef, useState } from 'react';
import './NotConnected.css';
import './Connected.css';
import './btn.css';
import { useNavigate } from 'react-router-dom';
import { callAPI } from './callAPI.js';
import { useTranslation } from "react-i18next";

function Connected({signOut, imagePath, setShowSearch, isShowing, newMessages}) {
  
  const pImage = {
    backgroundImage: imagePath && imagePath !== null ? `url('https://rockstoclimb.com/uploads/profiles/${imagePath}')` : 'url("/Images/defImage.png")'
  }
  const navigate = useNavigate();
  const [totalMessage, setTotalMessage] = useState(0)
  const [totalFromDb, setTotalFromDb] = useState(0)
  const [showBtn, setShowBtn] = useState(true)
  const [hidden, sethidden] = useState(false)

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Nettoyage à la destruction du composant
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const form = new FormData()
    form.append('type', 'get_unread_chats')

    callAPI("read", form)
    .then((data) => {
      setTotalFromDb(data.result)
      setTotalMessage(data.result)
    })
    .catch((error) => {
        console.error("API call failed:", error);
    });
  },[])


  useEffect(() => {
    setTotalMessage(totalFromDb + newMessages.length)
  },[newMessages])
  
  let sectionStyle = "Connected" + (showBtn ? "" : " inactiveConnected")

  const hiddenStyle = {
    display: hidden ? "none" : "flex"
  };

  const reversewhiddenStyle = {
    display: hidden ? "flex" : "none"
  };

  const rotateStyle = {
    transform: hidden
      ? (windowWidth < 768 ? "rotate(90deg)" : "rotate(180deg)")
      : (windowWidth < 768 ? "rotate(-90deg)" : "rotate(0deg)"),
    transition: "transform 0.9s ease"
  };

  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const toggleLang = currentLang === "en" ? "fr" : "en";
  const buttonText = toggleLang.toUpperCase();

  return (
    <>
      
      <div className={'ConnectedContainer' + (showBtn ? '':' innactiveContainer')}>
        <div className={sectionStyle}>
            <span id='chevron' className="material-symbols-outlined btnConnected" onClick={() => sethidden(!hidden)} style={rotateStyle}>chevron_right</span>
            <div className='separationBtnConnected'></div>
            <span id='signOut' className="material-symbols-outlined btnConnected" onClick={signOut} style={hiddenStyle} data-label={t("connected_signout")}>logout</span>
            {localStorage.getItem("role") == 1 && <span className="material-symbols-outlined adminBtn btnConnected" onClick={() => navigate("/Admin")} data-label={t("connected_admin")} style={hiddenStyle}>shield_person</span>}
            <span className="material-symbols-outlined save btnConnected" onClick={() => setShowSearch(!isShowing)} style={hiddenStyle} data-label={t("research")}>search</span>
            <span className="material-symbols-outlined rencontre btnConnected" onClick={() => navigate("/rencontre")} style={hiddenStyle} data-label={t("connected_meet")}>handshake</span>
            <div className='chatButtonAndNotif'>
              <span className='conversationBtnConnected btnConnected material-symbols-outlined' onClick={() => {navigate(`/chat/${localStorage.getItem("user_id")}`);}} data-label={t("connected_convo")} style={hiddenStyle}>
                chat
              </span>
              {totalMessage > 0 && <span className='conversationNotif'>{totalMessage}</span>}
            </div>
            <span id='lang' className="btnConnected" onClick={() => i18n.changeLanguage(toggleLang)} style={hiddenStyle}>{buttonText}</span>
            <div className='bkProfil ' onClick={() => {navigate(`/profil/${localStorage.getItem("user_id")}`)}}><div style={pImage} className='profil'></div></div>
            {totalMessage > 0 && <span style={reversewhiddenStyle} id='closeNotif' className='conversationNotif'>{totalMessage}</span>}
        </div>
      </div>
      
    </>
  );
}

export default Connected;